import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormModalBaseComponent } from '../../../../../../core/base/components/form-modal-base/form-modal-base.component';

import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ContractModel } from '../../../../../../core/models/contract.model';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ContractService } from '../../contract.service';
import moment from 'moment';
import { SnackbarService } from '../../../../../../core/services/snackbar.service';

@Component({
  selector: 'vex-contract-resume-create-update-delete',
  templateUrl: './contract-resume-create-update-delete.component.html',
  styleUrls: ['./contract-resume-create-update-delete.component.scss'],
})
export class ContractResumeCreateUpdateDeleteComponent extends FormModalBaseComponent<ContractModel> implements OnInit {
  form: UntypedFormGroup;
  loading = false;
  contract: ContractModel;
  denunciationDate: Date;
  minDenunciationDate: Date;
  maxDenunciationDate: Date;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<FormModalBaseComponent<ContractModel>>,
    public service: ContractService,
    public snackbarService: SnackbarService,
  ) {
    super(data, dialogRef, service);
    this.data = data;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initData();
    this.initForm();
  }

  async initData() {
    this.contract = this.data.contract;
    this.denunciationDate = this.data.contract.denunciationDate;
  }

  initForm() {
    this.form = new UntypedFormGroup({
      _id: new UntypedFormControl(this.contract._id),
      denunciationDate: new UntypedFormControl(this.denunciationDate, []),
    });

    this.MinMaxDenunciationDateFilter();
  }

  MinMaxDenunciationDateFilter() {
    // PRED-3003 : plage = [aujourd'hui, endValidityDate].
    // Remplace l'ancienne formule `startValidityDate + minNotice mois` qui rendait
    // la modale inutilisable dès que ce max passait dans le passé.
    this.minDenunciationDate = moment().startOf('day').toDate();
    this.maxDenunciationDate = this.contract.endValidityDate;
  }

  addItem(): void {
    this.loading = true;

    if (this.form.valid) {
      const sub = this.service
        .addDenunciationDate(this.contract._id, { denunciationDate: this.form.getRawValue().denunciationDate })
        .subscribe(
          result => {
            this.snackbarService.success('La date de dénonciation a été ajoutée');
            this.loading = false;
            this.close(result);
          },
          error => {
            this.snackbarService.warning('Une erreur est survenue');
            this.loading = false;
          },
        );
      this.subscription.add(sub);
    } else {
      this.onFormInvalid();
      this.loading = false;
    }
  }
}
